import Styles from "./index.module.scss";
import clsx from "clsx";

export const ModalInput = ({
  id,
  error,
  label,
  value,
  type = "text",
  isRequired = false,
  isReadOnly = false,
  placeholder = "",
  onChange,
}) => {
  return (
    <div className={clsx(Styles.wrapBox)}>
      <div className={clsx(Styles.wrapItem)}>
        <label className={clsx(Styles.label)} htmlFor={id}>
          {label}
        </label>

        <input
          id={id}
          name={id}
          value={value}
          onChange={onChange}
          className={clsx(isReadOnly ? Styles.disableInput : Styles.input)}
          type={type}
          required={isRequired}
          placeholder={placeholder}
          readOnly={isReadOnly}
        />
      </div>
      {error && <span className="error">{error.message}</span>}
    </div>
  );
};
